export default __webpack_public_path__ + "static/media/turn-ideas-into-reality-1024w.3abeefc1.png";